export const listenOpts = {
  passive: { passive: true },
  notPassive: { passive: false },
  passiveCapture: { passive: true, capture: true },
  notPassiveCapture: { passive: false, capture: true },
};

export function addEvents(ctx, targetName, events) {
  const name = `__e_${targetName}_event`;

  ctx[name] = ctx[name] ? ctx[name].concat(events) : events;

  events.forEach((event) => {
    const target = event[0];
    const type = event[1];
    const listener = ctx[event[2]];
    const opts = listenOpts[event[3]];

    target.addEventListener(type, listener, opts);
  });
}

export function cleanEvents(ctx, targetName) {
  const name = `__e_${targetName}_event`;

  if (!ctx[name]) return;

  ctx[name].forEach((event) => {
    const target = event[0];
    const type = event[1];
    const listener = ctx[event[2]];
    const opts = listenOpts[event[3]];

    target.removeEventListener(type, listener, opts);
  });

  ctx[name] = null;
}

export function eventPosition(e) {
  if (e.touches && e.touches[0]) {
    e = e.touches[0];
  } else if (e.changedTouches && e.changedTouches[0]) {
    e = e.changedTouches[0];
  } else if (e.targetTouches && e.targetTouches[0]) {
    e = e.targetTouches[0];
  }

  return {
    top: e.clientY,
    left: e.clientX,
  };
}
